import { render, staticRenderFns } from "./HabitResults.vue?vue&type=template&id=6989ee62&scoped=true&"
import script from "./HabitResults.vue?vue&type=script&lang=js&"
export * from "./HabitResults.vue?vue&type=script&lang=js&"
import style0 from "./HabitResults.vue?vue&type=style&index=0&id=6989ee62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989ee62",
  null
  
)

export default component.exports